import { estadosAfiliado } from "@/lib/affiliateEstados";

interface FiltrosAfiliadosProps {
  q: string;
  estado: string;
  tipo: string;
  resultCount: number;
  total: number;
  onQ: (value: string) => void;
  onEstado: (value: string) => void;
  onTipo: (value: string) => void;
  onClear: () => void;
}

const inputClass =
  "w-full rounded-md border border-background-300 bg-background-50 px-3.5 py-2.5 text-sm text-foreground-800 placeholder:text-foreground-400 transition-colors focus:border-primary-400 focus:outline-none focus:ring-2 focus:ring-primary-100";

export default function FiltrosAfiliados({
  q,
  estado,
  tipo,
  resultCount,
  total,
  onQ,
  onEstado,
  onTipo,
  onClear,
}: FiltrosAfiliadosProps) {
  const hayFiltros = Boolean(q || estado || tipo);

  return (
    <div className="rounded-lg border border-background-200 bg-background-50 p-4">
      <div className="grid grid-cols-1 gap-3 md:grid-cols-[1.6fr_1fr_1fr_auto]">
        <div className="relative">
          <i
            className="ri-search-line pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-base leading-none text-foreground-400"
            aria-hidden="true"
          ></i>
          <input
            type="search"
            value={q}
            onChange={(event) => onQ(event.target.value)}
            placeholder="Buscar por número, nombre, empresa, correo…"
            className={`${inputClass} pl-9`}
          />
        </div>
        <select value={estado} onChange={(event) => onEstado(event.target.value)} className={inputClass}>
          <option value="">Todos los estados</option>
          {estadosAfiliado.map((item) => (
            <option key={item.value} value={item.value}>
              {item.label}
            </option>
          ))}
        </select>
        <select value={tipo} onChange={(event) => onTipo(event.target.value)} className={inputClass}>
          <option value="">Todos los tipos</option>
          <option value="independiente">Propietario / Independiente</option>
          <option value="empresa">Empresa de transporte</option>
        </select>
        <button
          type="button"
          onClick={onClear}
          disabled={!hayFiltros}
          className="inline-flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-300 px-4 py-2.5 text-sm font-label font-medium text-foreground-700 transition-colors hover:bg-background-100 disabled:cursor-not-allowed disabled:opacity-40"
        >
          <i className="ri-filter-off-line text-base leading-none" aria-hidden="true"></i>
          Limpiar
        </button>
      </div>
      <p className="mt-3 text-xs text-foreground-500">
        Mostrando {resultCount} de {total} solicitudes de afiliación.
      </p>
    </div>
  );
}